import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStudentPaperAssignments,
  downloadOriginalAssignment,
  clearError,
} from "../paperAssignmentSlice";
import { fetchAssignmentList } from "../../assignment/assignmentSlice";
import StudentPaperAssignmentCalendar from "./StudentPaperAssignmentCalendar";

const PaperAssignmentTable = () => {
  const dispatch = useDispatch();
  const { student } = useSelector((state) => state.student);
  const { assignments, error } = useSelector(
    (state) => state.paperAssignment
  );
  const [finishedAssignments, setFinishedAssignments] = React.useState([]);

  useEffect(() => {
    if (student?.id) {
      dispatch(fetchStudentPaperAssignments(student.id));

      dispatch(fetchAssignmentList({ studentId: student.id, isFinished: true, page: 1, limit: 1000 }))
        .then((result) => {
          if (result.payload?.results) {
            setFinishedAssignments(result.payload.results);
          }
        });
    }
  }, [dispatch, student]);

  useEffect(() => {
    if (error) {
      alert(`오류: ${error.error || error}`);
      dispatch(clearError());
    }
  }, [error, dispatch]);

  const handleOriginalAssignmentDownload = async (s3Key) => {
    if (!student?.id) {
      alert("학생 정보를 찾을 수 없습니다. 다시 로그인 해주세요.");
      return;
    }

    try {
      const result = await dispatch(
        downloadOriginalAssignment({
          studentId: student.id,
          s3Key,
        })
      );

      if (downloadOriginalAssignment.fulfilled.match(result)) {
        const { download_url } = result.payload;
        window.open(download_url, "_blank");
      }
    } catch (downloadError) {
      console.error("Download error:", downloadError);
      alert("원본 과제 다운로드 중 오류가 발생했습니다.");
    }
  };

  return (
    <div
      style={{
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "20px",
      }}
    >
      <h2 style={{ marginBottom: "20px", color: "#333" }}>알림장 및 과제</h2>

      <StudentPaperAssignmentCalendar
        assignments={assignments}
        onlineAssignments={finishedAssignments || []}
        onDownloadHomework={handleOriginalAssignmentDownload}
      />
    </div>
  );
};

export default PaperAssignmentTable;
